import { get } from 'common';

const ADS_ROUTE = `${process.env.REACT_APP_API_CONFIG}ads`;


export class AdsService {
    private static instance: AdsService;

    static getInstance(): AdsService {
        if (!this.instance) {
            this.instance = new AdsService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${ADS_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${ADS_ROUTE}/${id}`);
    }
}
